// extracted by mini-css-extract-plugin
export default {"navbar":"Navigation_navbar__5KL9K","navlink":"Navigation_navlink__gYeZ0","link":"Navigation_link__13qe6","current":"Navigation_current__E3j6P"};